/* global window */

import { RouteHandler } from 'wee-routes';
import { $setRef } from 'core/dom';
import { $serialize } from 'core/types';
import $ from 'wee-dom';
import $events from 'wee-events';
import $location from 'wee-location';
import $fetch from 'wee-fetch';
import tabs from '../../content/tabs';

class Filter {
    constructor() {
        this.$filter = $(':filter');
        this.$container = $(':filteredItems');
        this.filterType = this.$filter.data('type');
        this.origin = $location.uri().origin;
        this.eventCategory = $location.uri().query['eventCategory'];
        this.classCategory = $location.uri().query['classCategory'];
    }

    /**
     * Load ajax template with query string
     */
    fetchTemplate(q) {
        let queryString = '';

        if (Object.getOwnPropertyNames(q).length) {
            queryString = `?${$serialize(q)}`;
        }

        $fetch.get(`${this.origin}/ajax/events`, {
            responseType: 'text',
            params: q,
        }).then(({ data }) => {
            this.$container.html(data);

            $setRef();
            tabs.init();

            window.history.replaceState({
                path: '/events',
            }, null, `/events${queryString}`);

        }).catch(e => console.error(e));
    }

    /**
     * Set query string based on filter
     */
    filter(el) {
        let currentQuery = $location.uri().query;

        let query = {
            ...currentQuery,
            [el.name]: el.value
        };

        this.fetchTemplate(query);
    }

    /**
     * Set query string based on tab
     */

    tab(tab) {
        let query = {};

        if ($(tab).data('id') == 'classes') {
            query = {
                classes: true,
            };
        }

        this.fetchTemplate(query);
    }
}

export default new RouteHandler({
    init() {
        const filter = new Filter();

        $events.on({
            [filter.$filter.sel]: {
                change(e, el) {
                    filter.filter(el);
                },
            },
            ':tabAction': {
                click(e, el) {
                    filter.tab(el);
                }
            }
        }, {
            delegate: ':filteredItems',
        });
    },
});
